exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-select[data-v-6b3a375d] {\n    font-size: 0.9rem !important;\n}\n", ""]);

// exports
